var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowForward = function SvgArrowForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "arrow_forward_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#arrow_forward_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.175 13H5a.97.97 0 0 1-.713-.287A.97.97 0 0 1 4 12q0-.424.287-.712A.97.97 0 0 1 5 11h11.175l-4.9-4.9a.92.92 0 0 1-.287-.7Q11 5 11.3 4.7q.3-.276.7-.287.4-.013.7.287l6.6 6.6q.15.15.212.325.063.176.063.375 0 .2-.062.375a.9.9 0 0 1-.213.325l-6.6 6.6a.93.93 0 0 1-.687.275q-.413 0-.713-.275-.3-.3-.3-.712 0-.413.3-.713z"
  }))));
};
export default SvgArrowForward;